const STORAGE_KEY = "lastSentVariantCodeMap";

function getLastSentMap() {
  return sessionStorage.getItem(STORAGE_KEY);
}

function setLastSentMap(value) {
  sessionStorage.setItem(STORAGE_KEY, value);
}

function updateVariantCodeMap() {
  const el = document.getElementById("variant-code-map-data");
  if (!el) return;

  try {
    const variantCodeMap = JSON.parse(el.textContent);

    if (!variantCodeMap) return;

    const serialized = JSON.stringify(variantCodeMap);

    if (serialized === getLastSentMap()) return;

    fetch("/cart/update.js", {
      method: "POST",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify({attributes: {_variant_code_map: serialized}}),
    })
      .then((response) => {
        if (response.ok) {
          setLastSentMap(serialized);
          console.log("OK: Cart attributes updated with variant code map");
        }
      })
      .catch((error) => {
        console.error("Error updating cart attributes with variant code map:", error);
      });
  } catch (e) {
    console.error("Error parsing variant code map:", e);
  }
}

updateVariantCodeMap();
document.addEventListener("cart:item-added", updateVariantCodeMap);
document.addEventListener("line-item:change:end", updateVariantCodeMap);
